var map = {
	"./browser-chrome.png": 2745,
	"./browser-edge-new.png": 1397,
	"./browser-edge.png": 2283,
	"./browser-firefox.png": 316,
	"./browser-safari.png": 23,
	"./frontier.png": 2677,
	"./salesforce.png": 8723,
	"./techsee-light.png": 9242,
	"./techsee.png": 2041,
	"./unsupported.png": 4909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8973;